export enum SocketNamespace {
  TalentAcquisition = 'talent-acquisition',
  Outreach = 'outreach',
  User = 'user',
  RecruiterAgent = 'recruiter-agent'
}
